import { Vue } from 'types-vue';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/es';

import 'element-ui/lib/theme-chalk/index.css';
import '../styles/element-variables.scss'

Vue.use(ElementUI, { locale });